import React from 'react';

import { RecursiveMenu } from '@uncinc/react-drupal-core';
import { Container, Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { ContactMenu, SocialMenu } from '../../../../components';

import './style.scss';

const menuLi = ({
  children, ...props
}) => (
  <li {...props}>
    <Icon name="chevron_bold" />{children}
  </li>
);

const Overlay = ({ toggleOverlayOpen }) => {
  return (
    <div className="Overlay">
      <div className="Overlay__background">
        <Container>
          <div className="Overlay__wrapper">
            <div className="Overlay__wrapper__section mainsecondary">
              <RecursiveMenu
                menuId="main"
                maxLevel={2}
                MenuItemLink={menuLi}
                onClickFunction={() => toggleOverlayOpen()}
              />
              <RecursiveMenu
                menuId="secondary"
                maxLevel={2}
                MenuItemLink={menuLi}
                onClickFunction={() => toggleOverlayOpen()}
              />
            </div>

            <div className="Overlay__wrapper__section contactsocial">
              <ContactMenu toggleOverlayOpen={toggleOverlayOpen} />
              <SocialMenu colorClass="white" />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Overlay;
